import { doc, getDoc, query, where, getDocs, collection, setDoc } from "firebase/firestore";

import { firestoreDb } from "../firebase";
import { ACCOUNTS, EMAIL, EQUALS } from "../constants";

const addAccount = async (account: Account): Promise<void> => {
  try {
    const accountsSnapshot = await getDocs(query(collection(firestoreDb, ACCOUNTS), where(EMAIL, EQUALS, account.email)));
    if (accountsSnapshot.empty) {
      await setDoc(doc(firestoreDb, ACCOUNTS, account.id), { ...account });
    }
  } catch (e) {
    console.error("Error creating new account: ", e);
  }
}

const getAccountById = async (userId: string) : Promise<Account | null> => {
  try {
    const accountRef = doc(firestoreDb, ACCOUNTS, userId);
    const account = await getDoc(accountRef);
    if (account.exists()) {
      return account.data() as Account;
    }
    return null;
  } catch (e) {
    console.error("Error getting account by id: ", e);
  }
  return null;
}

const UserService = {
  addAccount,
  getAccountById
}

export default UserService;
